import { cn } from '@shared/utils/utils';
import * as React from 'react';

function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[ -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');
}

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & { 'data-testid'?: string }
>(({ className, id, placeholder, 'data-testid': testId, ...props }, ref) => {
  const generatedTestId =
    testId ??
    (id
      ? `textarea-${slugify(id)}`
      : placeholder
        ? `textarea-${slugify(placeholder)}`
        : 'textarea');

  return (
    <textarea
      className={cn(
        'flex w-full rounded-md border px-3 py-2 text-base shadow-sm transition-colors placeholder:text-default-text focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'border-card-border bg-card-bg text-foreground',
        // Autofill para textarea - mantiene consistencia con Input
        '[&:-webkit-autofill]:!bg-transparent [&:-webkit-autofill]:!shadow-[inset_0_0_0px_1000px_var(--wrh-card-bg)]',
        '[&:-webkit-autofill]:!text-[var(--wrh-text)] [&:-webkit-autofill]:!transition-[background-color] [&:-webkit-autofill]:!duration-[5000s]',
        '[&:-webkit-autofill:hover]:!bg-transparent [&:-webkit-autofill:hover]:!shadow-[inset_0_0_0px_1000px_var(--wrh-card-bg)]',
        '[&:-webkit-autofill:focus]:!bg-transparent [&:-webkit-autofill:focus]:!shadow-[inset_0_0_0px_1000px_var(--wrh-card-bg)]',
        '[&:-webkit-autofill:active]:!bg-transparent [&:-webkit-autofill:active]:!shadow-[inset_0_0_0px_1000px_var(--wrh-card-bg)]',
        className
      )}
      ref={ref}
      id={id}
      placeholder={placeholder}
      data-testid={generatedTestId}
      {...props}
    />
  );
});
TextArea.displayName = 'TextArea';

export { TextArea };
